import { RootState } from 'data/root.reducers';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ModalDialog from '../../shared/modal/dialog';

interface DeleteUserArgs {
  wId: any;
  user: string;
}

class UserDeleteUser extends React.Component<any, any> {
  handleDelete = () => {
    const {
      deleteUserAndRefresh,
      externalDashboardIP,
      logiSupervisorUserName,
      logiSupervisorPswd,
      location,
    } = this.props;

    const { selection } = location.state;

    selection
      .map((x: any) => ({ wId: x.id, user: x.userID }))
      .forEach(({ wId, user }: DeleteUserArgs) => {
        deleteUserAndRefresh({
          id: String(wId),
          user,
          externalDashboardIP,
          logiSupervisorUserName,
          logiSupervisorPswd,
        });
      });
  }

  render() {
    const { t } = this.props;
    const { selection } = this.props.location.state;
    const displayMessage = t('user.deletePopup.message', { name: selection[0].userID });
    return (
      <ModalDialog
        onSubmit={this.handleDelete}
        width="500px"
        {...this.props}
        actionText={t('user.deletePopup.action')}
        displayMessage={displayMessage}
      />
    );
  }
}

const mapStateToProps = ({
  discoveryXcipio: {
    discoveryXcipioSettings: {
      externalDashboardIP,
      logiSupervisorUserName,
      logiSupervisorPswd,
    },
  },
}: RootState) => ({
  externalDashboardIP,
  logiSupervisorUserName,
  logiSupervisorPswd,
});

export default withTranslation('translation', { withRef: true })(connect(mapStateToProps, null, null, { forwardRef: true })(
  UserDeleteUser,
));
